export const milliseconds = {
  oneSecond: 1000,
  fiveSeconds: 5 * 1000,
  oneMinute: 60 * 1000,
  oneDay: 24 * 60 * 60 * 1000,
  oneWeek: 7 * 24 * 60 * 60 * 1000,
}
